import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;

const CLASS_LIGHT_CONTRAST = "incluway-light-contrast";
const STYLE_ID = "incluway-light-contrast-style";
const EXCLUDE = "#incluway-widget-root";

export function enableLightContrast() {
  ROOT.classList.remove("incluway-dark-contrast", "incluway-high-contrast");
  ROOT.classList.add(CLASS_LIGHT_CONTRAST);

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS_LIGHT_CONTRAST} body {
  background: #ffffff !important;
}

/* Base: unify borders */
html.${CLASS_LIGHT_CONTRAST} *:not(${EXCLUDE}):not(${EXCLUDE} *) {
  border-color: rgba(17, 24, 39, 0.16) !important;
}

/* Surfaces: subtle “paper” look */
html.${CLASS_LIGHT_CONTRAST} body :is(
  main, section, article, aside, header, footer, nav,
  div, form, fieldset, table, thead, tbody, tfoot, tr, td, th,
  ul, ol, li, blockquote
):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background-color: rgba(17, 24, 39, 0.02) !important;
}

/* Headings */
html.${CLASS_LIGHT_CONTRAST} :is(h1,h2,h3,h4,h5,h6):not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #0b1220 !important;
}

/* Paragraph / small text */
html.${CLASS_LIGHT_CONTRAST} :is(p,span,li,td,th,label,small):not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #111827 !important;
}

/* Inputs */
html.${CLASS_LIGHT_CONTRAST} :is(input, textarea, select, button):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: #ffffff !important;
  color: #111827 !important;
  border: 1px solid rgba(17, 24, 39, 0.22) !important;
  box-shadow: none !important;
}

html.${CLASS_LIGHT_CONTRAST} :is(input, textarea):not(${EXCLUDE}):not(${EXCLUDE} *)::placeholder {
  color: rgba(17, 24, 39, 0.55) !important;
}

/* Links */
html.${CLASS_LIGHT_CONTRAST} a:not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #0048ff !important;
  text-decoration: underline !important;
  text-decoration-thickness: 2px !important;
  text-underline-offset: 3px !important;
}

html.${CLASS_LIGHT_CONTRAST} a:visited:not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #5b21b6 !important;
}

/* Focus */
html.${CLASS_LIGHT_CONTRAST} :is(a,button,input,textarea,select,[tabindex]):focus-visible:not(${EXCLUDE}):not(${EXCLUDE} *) {
  outline: 3px solid #146ff8 !important;
  outline-offset: 3px !important;
  border-radius: 6px !important;
}

/* Tables */
html.${CLASS_LIGHT_CONTRAST} table:not(${EXCLUDE}):not(${EXCLUDE} *) {
  border-collapse: collapse !important;
}

html.${CLASS_LIGHT_CONTRAST} th:not(${EXCLUDE}):not(${EXCLUDE} *),
html.${CLASS_LIGHT_CONTRAST} td:not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(17, 24, 39, 0.02) !important;
}

html.${CLASS_LIGHT_CONTRAST} tr:nth-child(even) td:not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(17, 24, 39, 0.01) !important;
}

/* Code blocks */
html.${CLASS_LIGHT_CONTRAST} :is(code,pre):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(17, 24, 39, 0.04) !important;
  color: #0b1220 !important;
  border: 1px solid rgba(17, 24, 39, 0.18) !important;
}

/* Blockquotes */
html.${CLASS_LIGHT_CONTRAST} blockquote:not(${EXCLUDE}):not(${EXCLUDE} *) {
  border-left: 4px solid rgba(0, 72, 255, 0.55) !important;
  padding-left: 12px !important;
  color: rgba(17, 24, 39, 0.92) !important;
}

/* Media */
html.${CLASS_LIGHT_CONTRAST} :is(img, video, picture, svg, canvas):not(${EXCLUDE}):not(${EXCLUDE} *) {
  filter: none !important;
  background: transparent !important;
}

/* Widget host hard exclusion */
html.${CLASS_LIGHT_CONTRAST} ${EXCLUDE} {
  background: initial !important;
  color: initial !important;
  border-color: initial !important;
  filter: none !important;
}
`.trim(),
  );
}

export function disableLightContrast() {
  ROOT.classList.remove(CLASS_LIGHT_CONTRAST);
  removeStyleTag(STYLE_ID);
}
